<template>
  <section class="Products" id="products-page"
  v-loading.fullscreen.lock="loading"
  element-loading-text="Fetching products..."
  element-loading-background="white">
    <!--    <products-filter-navbar />-->
    <!--    <products-filter />-->
    <el-row>
      <el-col :sm="4" :lg="4" class="sidebar">
        <products-sidebar :current-category="category" />
      </el-col>
      <el-col :sm="20" :lg="20">
        <section class="all-products section-pad">
          <product-filter-component @filters:apply="fetchByFilters"/>
          <el-row type="flex" justify="center">
            <el-col :lg="20" :xs="20" :sm="20" :md="20" :xl="20">
              <el-row :gutter="30" type="flex" class="flex-wrap">
                <el-col
                  :xs="24"
                  :sm="12"
                  :lg="8"
                  :md="12"
                  :xl="8"
                  v-for="(item, index) in products.data"
                  :key="index"
                  class="clearfix"
                >
                  <product-item-component :product="item"/>
                </el-col>
              </el-row>
              <el-row v-show="products.length === 0" class="no-products">
                <h2>No products</h2>
              </el-row>
            </el-col>
          </el-row>
        </section>
        <!-- pagination -->
      </el-col>
    </el-row>
    <footer class="container" v-if="getProducts">
      <el-pagination
        class="mb-40 text-center"
        background
        :page-size.sync="getProducts.per_page"
        :current-page.sync="getProducts.current_page"
        layout="prev, pager, next"
        :total.sync="getProducts.total"
        @current-change="fetchProducts"
        :hide-on-single-page="true"
      ></el-pagination>
    </footer>
    <!-- ./pagination -->
  </section>
</template>

<script>
import LayoutDefault from "@/layouts/LayoutDefault";
import ProductsSidebar from "@/components/ProductsSidebar";
import { mapGetters } from "vuex";
import NProgress from "nprogress";
import ProductItemComponent from "../../components/products/ProductItemComponent";
import filter_products from "../../mixins/filter_products";
import ProductFilterComponent from "../../components/products/ProductFilterComponent";
export default {
  data() {
    return {
      loading: false,
      filters: {
        order: 'id',
        sort: 'desc'
      }
    };
  },
  mixins: [filter_products],
  computed: {
    ...mapGetters("products", ["getProducts"]),
    products() {
      return this.getProducts || [];
    },
    category() {
      return this.$route.params.category;
    },
    page() {
      return this.$route.query.page || 1
    }
  },
  async created() {
    this.$emit("update:layout", LayoutDefault);
    this.$root.$emit("closenav", false);
    await this.fetchProducts(this.page, this.params);
  },
  watch: {
    category: function() {
      return this.$route.params.category;
    },
    async $route() {
      await this.fetchProducts(1, this.$route.params.category)
    }
  },
  components: {
    ProductFilterComponent,
    ProductItemComponent,
    ProductsSidebar
  },
  methods: {
    async fetchByFilters(params) {
      this.filters = params
      await this.fetchProducts(1, params)
    },
    // fetch products and for pagination
    async fetchProducts(page, params = {}) {
      this.loading = true;
      params = JSON.stringify(params) === '{}' ? this.filters : params
      NProgress.start();
      if (params.order) {
        await this.$store.dispatch("products/fetchByCategory", {
          category: this.category,
          page: page,
          order: params.order,
          sort: params.sort
        });
      } else {
        await this.$store.dispatch("products/fetchByCategory", {
          category: this.category,
          page: page,
          order: params.order,
          sort: params.sort
        });
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      NProgress.done();
      this.loading = false;
    }
  }
};
</script>
<style scoped lang="scss">
.no-products {
  height: 80vh;
  font-size: 3rem;
  text-align: center;
  display: flex;
  text-transform: uppercase;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  color: #11233f;
}

@media all and (max-width: 768px) {
  .sidebar {
    display: none;
  }
}

.section-pad {
  padding-top: 0 !important;
}

.sidebar {
  position: sticky;
  left: 3%;
  top: 14%;
  margin-bottom: 2%;
  z-index: 10001;
}

.router-link-active {
  color: #11233f !important;
}
</style>
